import { createRoot } from 'react-dom/client';
import { initAppFrameApi } from './api/app-frame-api';
import { App } from './components/App';
import { initSentry } from './services/sentry';
import { initializeUserTracking } from './services/userTracking';
import { trackAnalytics } from './services/analytics';
import { getAccessToken, getUser } from './services/auth/AuthProvider';
import { loadAppConfiguration } from './state/configuration/application-configuration';
import { router } from './services/routing/router';
import { resetBrowserTitleStatusOnNavigation } from './state/notifications/browser-title';

resetBrowserTitleStatusOnNavigation(router);
initSentry();
initAppFrameApi({
  getAccessToken,
  getUser,
  trackAnalytics,
  getAppConfiguration: () => {
    const configuration = loadAppConfiguration();
    if (!configuration) {
      throw new Error('The application configuration has not been completed.');
    }
    return configuration;
  },
});
initializeUserTracking(router);

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Unable to find root element to render the application.');
}
const root = createRoot(rootElement);
root.render(<App />);
